import { render } from "./GamePopUp.vue?vue&type=template&id=8f9f562e&scoped=true&ts=true&class=popup"
import script from "./GamePopUp.vue?vue&type=script&lang=ts"
export * from "./GamePopUp.vue?vue&type=script&lang=ts"

import "./GamePopUp.vue?vue&type=style&index=0&id=8f9f562e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9f562e"]])

export default __exports__